import(/* webpackMode: "eager" */ "/vercel/path0/apps/ez-mining/src/app/global-error.tsx");
